import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';

@Component({
  selector: 'app-icustomer-booth-change-log',
  templateUrl: './icustomer-booth-change-log.component.html',
  styleUrls: ['./icustomer-booth-change-log.component.scss']
})
export class IcustomerBoothChangeLogComponent implements OnInit {

  is_data_available: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  icustomer_business_change_log_data: any = [];
  title: any;

  // Filter properties
  employeeTypes = ['Employee', 'Ex - employee'];
  selectedEmployeeType: string = '';
  selectedMonth: number = new Date().getMonth() + 1; // Current month (1-12)
  selectedYear: number = new Date().getFullYear(); // Current year

  // Download properties
  isDownloading: boolean = false;
  document_file: any = null;

  // Month names for display
  monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];

  // Available months and years
  months = [
    { value: 1, name: 'January' },
    { value: 2, name: 'February' },
    { value: 3, name: 'March' },
    { value: 4, name: 'April' },
    { value: 5, name: 'May' },
    { value: 6, name: 'June' },
    { value: 7, name: 'July' },
    { value: 8, name: 'August' },
    { value: 9, name: 'September' },
    { value: 10, name: 'October' },
    { value: 11, name: 'November' },
    { value: 12, name: 'December' }
  ];

  years: number[] = [];

  constructor(private httpService: HttpService, private global: GlobalService) {
    this.is_data_available = false;
    this.title = this.global._active_display_name;

    // Generate years from 2020 to current year
    const currentYear = new Date().getFullYear();
    for (let year = 2020; year <= currentYear; year++) {
      this.years.push(year);
    }

    this.httpService.serveICustomerBusinessChangeLog().subscribe((data) => {
      this.icustomer_business_change_log_data = data;
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
    });
  }

  ngOnInit() {
  }

  // Validate that selected month/year is not greater than current month/year
  isValidMonthYear(): boolean {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // JavaScript months are 0-based
    const currentYear = currentDate.getFullYear();

    if (this.selectedYear > currentYear) {
      return false;
    }

    if (this.selectedYear === currentYear && this.selectedMonth > currentMonth) {
      return false;
    }

    return true;
  }

  // Format month and year as "MAY 2025"
  formatMonthYear(): string {
    const monthName = this.monthNames[this.selectedMonth - 1].toUpperCase();
    return `${monthName} ${this.selectedYear}`;
  }

  // Check if download button should be enabled
  canDownload(): boolean {
    return this.selectedEmployeeType !== '' && this.isValidMonthYear() && !this.isDownloading;
  }

  // Download Excel file
  downloadExcel() {
    if (!this.canDownload()) {
      if (!this.isValidMonthYear()) {
        alert('Please select a month and year that is not greater than the current month and year.');
        return;
      }
      if (this.selectedEmployeeType === '') {
        alert('Please select an employee type.');
        return;
      }
      return;
    }

    this.isDownloading = true;
    this.document_file = null;

    const requestData = {
      employee_type: this.selectedEmployeeType,
      month: this.formatMonthYear()
    };

    this.httpService.serveICustomerBusinessChangeLogExcelFilterWithParams(requestData).subscribe((data) => {
      this.document_file = data;
      this.isDownloading = false;

      // Check if data is available and trigger download
      if (this.document_file && this.document_file['is_data_available'] && this.document_file['excel']) {
        this.downloadFile();
      } else {
        alert('No data available for the selected filters.');
      }
    }, (error) => {
      console.error('Download error:', error);
      this.isDownloading = false;
      alert('Error downloading file. Please try again.');
    });
  }

  // Download the file
  downloadFile() {
    if (this.document_file && this.document_file['is_data_available'] && this.document_file['excel']) {
      const linkSource = 'data:application/xlsx;base64,' + this.document_file['excel'];
      const downloadLink = document.createElement('a');
      const fileName = this.document_file['file_name'] || `icustomer_booth_change_log_${this.formatMonthYear()}.xlsx`;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }
  }
}
